// extracted by mini-css-extract-plugin
export default {"heading":"ViewMoreAppointmentDetailsModal_heading__HV44J"};